import { GetUserAttributesResponse } from "../api/usersApi";
import { createGenericFormSlice, SliceState } from "./genericFormSlice";

const formSlice = createGenericFormSlice({
  name: "userTab",
  initialState: {} as SliceState<GetUserAttributesResponse>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const userTabReducer = formSlice.reducer;
export default userTabReducer;
